import { useSelector } from "react-redux";
import {
  fetch,
  getLayerIdByName,
  getProjectionCode,
  searchLayerRequest,
  trans,
} from "../../lib/utils";
import "./style.css";
import store from "../../stores/store";
import {
  formatSearchResultsFromServiceResponse,
  showFeature,
  showFeatureDetails,
} from "../../lib/featureUtils";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { useEffect, useState } from "react";
import md5 from "md5";
import { getLayerById } from "../map/mapUtils";

function QuickSearch() {
  const quicksearchOptions = useSelector(
    (state) => store.getState().map.quickSearchOptions
  );

  const [results, setResults] = useState([]);
  const [resultsDisplay, setResultsDisplay] = useState({});

  const [loader, setLoader] = useState(false);

  useEffect(() => {
    let displayAttributes = {};
    quicksearchOptions.forEach((service, idx) => {
      service.layers.forEach((layer, lid) => {
        displayAttributes[getLayerIdByName(layer.name, service.url)] = {
          label: layer.label,
          displayAttributes: layer.displayAttributes,
        };
      });
    });

    setResultsDisplay(displayAttributes);
  }, []);

  const onChange = (e) => {
    setResults([]);
    if (e.target.value.length > 3) {
      let request = [];

      setLoader(true);

      quicksearchOptions.forEach((service, idx) => {
        service.layers.forEach((layer, lid) => {
          if (
            layer.checked &&
            getLayerById(getLayerIdByName(layer.name, service.url))
          ) {
            let searchLayer = {
              layer: {
                name: layer.name,
                id: getLayerIdByName(layer.name, service.url),
              },
              source: {
                url: service.url,
                type: service.type,
              },
            };

            let cqlFilter = layer.searchAttributes
              .map((el) => {
                for (var k in el) {
                  if (el[k] === "=") {
                    if (!isNaN(e.target.value)) {
                      return k.concat(" =", e.target.value, "");
                    }
                  } else {
                    return k.concat(" like '%25", e.target.value, "%25'");
                  }
                }
              })
              .filter((o) => {
                return o;
              });

            request.push(
              searchLayerRequest(
                searchLayer.layer,
                searchLayer.source,
                cqlFilter.join(" OR "),
                null
              )
            );
          }
        });
      });

      fetch(window["appConfig"]()["api"](), "POST", {}, request, (resp) => {
        let results = [];

        if (resp.data) {
          resp.data.forEach((response) => {
            if (response._response) {
              if (response._response._attributes) {
                response._response._attributes.forEach((result) => {
                  let r = result[0];
                  r.layerLabel = response._response._layerId;
                  results.push(r);
                });
              }
            }
          });
        }

        setLoader(false);

        setResults(results);
      });
    }
  };

  return (
    <div className="quicksearch">
      <div className="d-flex mb-1" style={{ justifyContent: "flex-end" }}>
        <div>
          <input
            type="text"
            className="form-control quicksearch-text"
            placeholder={trans("Search for features").concat("...")}
            aria-label="quicksearch"
            aria-describedby="basic-addon1"
            onChange={onChange}
          />
          {loader ? (
            <img
              src={window["appConfig"]()
                ["path"]()
                .concat("assets/images/loading.gif")}
              className="loader"
            ></img>
          ) : (
            ""
          )}
        </div>

        <div
          className="input-group-text border bg-white"
          onClick={() => {
            setResults([]);
          }}
        >
          <span
            className=" pointer"
            id="basic-addon1"
            data-bs-toggle="collapse"
            data-bs-target=".quicksearch-options"
          >
            <i className="fas fa-cog"></i>
          </span>
        </div>
      </div>
      <div className="collapse quicksearch-options bg-white rounded p-2">
        {quicksearchOptions.map((service, idx) => {
          return service.layers.map((layer, lid) => {
            return (
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={layer.checked}
                  onChange={(e) => {
                    store.dispatch({
                      type: "map/quicksearch/update",
                      payload: {
                        serviceIndex: idx,
                        layerIndex: lid,
                        checked: e.target.checked,
                      },
                    });
                  }}
                  id={"check".concat(idx, lid)}
                />
                <label
                  className="form-check-label"
                  htmlFor={"check".concat(idx, lid)}
                >
                  {layer.label}
                </label>
              </div>
            );
          });
        })}
      </div>
      {results.length > 0 ? (
        <div className="quicksearch-results bg-white mt-1 border rounded">
          <PerfectScrollbar style={{ maxHeight: "12rem" }}>
            <ul>
              {results.map((el) => {
                return (
                  <li
                    className="pointer"
                    onClick={() => {
                      let feature = {
                        projection: getProjectionCode(el._srsName),
                        url: el._featureUrl,
                        layerId: el._layerId,
                      };

                      showFeatureDetails(feature);
                      showFeature(feature);
                    }}
                  >
                    <span className="d-block">
                      {resultsDisplay[el._layerId]?.displayAttributes.map(
                        (attr) => {
                          return el[attr] ? el[attr].concat(" ") : " ";
                        }
                      )}
                    </span>
                    <span className="small text-secondary">
                      {resultsDisplay[el._layerId].label}
                    </span>
                  </li>
                );
              })}
            </ul>
          </PerfectScrollbar>
          <div
            className=" small mt-2 border-top ps-2 d-block d-flex"
            style={{ backgroundColor: "#eaeaea" }}
          >
            <span className="w-50">
              {trans("Total").concat(": ", results.length)}
            </span>
            <span
              className="pointer pe-2 w-50 text-end"
              onClick={() => {
                setResults([]);
              }}
            >
              <i className="fas fa-times me-1 small"></i>
              {trans("Close")}
            </span>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default QuickSearch;
